import axios from "@/services/axios.config";
import { toastOnError } from "@/utils/toastOnError";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

const postSummary = async (data: FormData) =>
	axios
		.post("/methodology/additional-info/add", data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
		.then((res) => res.data.data)
		.catch((err) => Promise.reject(err.response.data as APIResponse));

export default function usePostAdditionalInfo(infoType: string, onSuccessFn?: () => void) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: ["postAdditionalInfo"],
		mutationFn: postSummary,
		retry: 0,
		onSuccess() {
			queryClient.invalidateQueries({ queryKey: ["getAdditionalInfo"] });
			if (onSuccessFn) {
				onSuccessFn();
			}
			toast.success(`${infoType} updated successfully`);
		},
		onError: (err: APIResponse) => {
			toastOnError(err, `Failed to update ${infoType}`);
		},
	});
}
